/*
This lets a clickable element (the "trigger" target) open or close an accordion style element
which is achieved by adding/removing a hidden class from the subject or "content" target.
*/
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "content"];

  static values = {
    openByDefault: { type: Boolean, default: true },
  }  

  connect() {
    if (this.openByDefaultValue) {
      this.open();
    }
    // Also a hack because you had to click the first accordion twice to get it to open before I added this.
    this.triggerTarget.addEventListener("click", () => {
      this.toggle();
    });
  }

  toggle() {
    if (this.contentTarget) {
      if (this.isOpen()) {
        this.close();
      } else {
        this.open();
      }
    }
  }

  open() {
    this.contentTarget.classList.remove("hidden");
    this.triggerTarget.querySelector("[data-accordion-icon]").classList.add("rotate-90");
  }

  close() {
    this.contentTarget.classList.add("hidden");
    this.triggerTarget.querySelector("[data-accordion-icon]").classList.remove("rotate-90");
  }

  isOpen() {
    return !this.contentTarget.classList.contains("hidden");
  }
}
